<div class="widget-test-container">
  <h1>Widget Testing (Iframe Integration)</h1>

  <div class="widget-section">
    <h2>Quality - Hotel Landing Page</h2>
    <div class="widget-wrapper widget-wrapper--preview">
      <iframe [src]="iframeQualityLandingUrl" class="widget-iframe landing" scrolling="no"></iframe>
    </div>
  </div>

  <div class="widget-section">
    <h2>Aiden - Hotel Landing Page</h2>
    <div class="widget-wrapper widget-wrapper--preview">
      <iframe [src]="iframeAidenLandingUrl" class="widget-iframe landing" scrolling="no"></iframe>
    </div>
  </div>

  <div class="widget-section">
    <h2>Skavsta</h2>
    <div class="widget-wrapper widget-wrapper--preview">
      <iframe [src]="iframeSimpleUrl" class="widget-iframe short" scrolling="no"></iframe>
    </div>
  </div>

  <div class="widget-section">
    <h2>Flygets</h2>
    <div class="widget-wrapper widget-wrapper--preview">
      <iframe [src]="iframeAdvancedUrl" class="widget-iframe advanced" scrolling="no"></iframe>
    </div>
  </div>

  <div class="widget-section">
    <h2>Quality - Short-term</h2>
    <div class="widget-wrapper widget-wrapper--preview">
      <iframe [src]="iframeShortTermQualityUrl" class="widget-iframe short" scrolling="no"></iframe>
    </div>
  </div>

  <div class="widget-section">
    <h2>Quality - Park-and-Fly</h2>
    <div class="widget-wrapper widget-wrapper--preview">
      <iframe [src]="iframeParkAndFlyQualityUrl" class="widget-iframe parkfly" scrolling="no"></iframe>
    </div>
  </div>

  <div class="widget-section">
    <h2>Aiden - Short-term</h2>
    <div class="widget-wrapper widget-wrapper--preview">
      <iframe [src]="iframeShortTermAidenUrl" class="widget-iframe short" scrolling="no"></iframe>
    </div>
  </div>

  <div class="widget-section">
    <h2>Aiden - Park-and-Fly</h2>
    <div class="widget-wrapper widget-wrapper--preview">
      <iframe [src]="iframeParkAndFlyAidenUrl" class="widget-iframe parkfly" scrolling="no"></iframe>
    </div>
  </div>

</div>